import { createContext } from "react";
import type { SettingsSectionId } from "@/features/settings";

// Settings must outlive the mobile navigation drawer that opens them.
export const SettingsNavigation = createContext<((section: SettingsSectionId) => void) | null>(null);
